module.exports = __webpack_public_path__ + "img/occidental-logo.e2ece2f5.png";